import styled from "styled-components";
import RadiusGenerate from "@helpers/radius.generate";
import ButtonTransparent from "@atoms/button.transparent";
import {CaptionContainer} from "./caption";
import {Container as DropdownContainer} from './dropdown'
import {Header as DropdownHeader} from './dropdwon.header'
import {Container as ItemsContainer} from './lists'

export const LoadingBox = styled.span`
    position: absolute;
    top: 8px;
    left: 12px;
    justify-content: center;
    
    .modal-filter-body & {
        position: static;
        margin-right: 14px;
        margin-left: 2px;
    }
    
    .disabled & ,.disabled & [role="button"]{
        cursor: not-allowed;
    }
`;

export const ClearButton = styled(ButtonTransparent)`
    display: none;
    position: absolute;
    background-color: ${props => props.theme.primary};
    width: 19px;
    min-width: 19px;
    height: 19px;
    min-height: 19px;
    left: 7px;
    outline: 0;
    line-height: 0;
    border: 0;
    justify-content: center;
    top: 50%;
    transform: translate(0, -50%);
    
    .modal-filter-body & {
        position: static;
        left: 0;
        width: 24px;
        height: 24px;
        min-width: 24px;
        min-height: 24px;
        background-color: ${props => props.theme.danger};
        margin-right: 8px;
        top: 0;
        transform: none;
        
        &:hover {
            background-color: #fcc5b2;
        }
        
        .icons {
            width: 8px;
            min-width: 8px;
            max-width: 8px;
            height: 8px;
            min-height: 8px;
            max-height: 8px;
        }
        
        svg {
            g,path {
                stroke: ${props => props.theme.dangerText};
                stroke-width: 2px;
            }
        }
    }
    
    svg {
        g,path {
            stroke: #ffffff;
            stroke-width: 2.2px;
        }
    }
`;

export const Toggle = styled.div`
    width: 100%;
    cursor: pointer;
    height: 40px;
    padding: 8px 16px 8px 34px;
    
    .search-filter-wrapper & {
        height: 100%;
    }
   
   .modal-filter-body & {
        height: auto !important;
   }
    
    &:after {
        display: ${props => props.showRangeInputInCaption ? 'none' : 'block'};
        position: absolute;
        left: 16px;
        content: '';
        border: 0;
        width: 10px;
        height: 10px;
        background-image: url(/_img/icons/chevron-down.svg);
        background-repeat: no-repeat;
        background-size: 10px 10px;
        background-position: 50% 50%;
        cursor: pointer;
        stroke: currentColor;
        stroke-width: 1.5;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    
    &.disabled {
        &:after {
            display: none !important;
        }
    }
    
    .modal-filters &:after{
        background-image: url(/_img/icons/chevron-left.svg);
    }
    
    .modal-filter-body &{
        padding-left: 0;
        
        &:after {
            left: 0;
        }
    }
    
    &.is-loading {
        &:after {
            display: none;
        }
        
        &.disabled {
            cursor: not-allowed;
        }
    }
`;

export const Container = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.theme.white};
    border: solid 1px ${props => props.theme.gray250};
    ${RadiusGenerate('8px')};
    
    &.show {
        border:solid 1px ${props => props.theme.black} !important;
        background: ${props => props.theme.white} !important;
        
        ${Toggle}:after {
            display: ${props => props.showRangeInputInCaption ? 'none' : 'block'} !important;
            background-image: url(/_img/icons/chevron-up.svg) !important;
        }
        
        ${ClearButton} {
            display: none !important;
        }
    }
    
    &.selected {
        //border: solid 1px ${props => props.theme.dark};
        
        ${CaptionContainer} {
            color: ${props => props.theme.dark};
        }
        
        ${ClearButton} {
            display: ${props => props.showRangeInputInCaption ? 'none' : 'flex'};
            align-items: center;
        }
        
        ${Toggle}:after {
            display: ${props => props.clearabel ? 'none' : 'block'};
        }
    }
    
    .modal-filter-body & {
        position: static;
        width: 100%;
        height: auto;
        margin-left: 0;
        background: none;
        border-radius: 0;
        border: 0;
        border-bottom: 1px solid ${props => props.showRangeInputInCaption ? 'transparent' : props.theme.gray200};
        
        &.show{
            border: 0 !important;
        }
        
        ${Toggle} {
            padding: 16px 0;
            &:after {
                width: 20px;
                margin-left: 0;
            }
        }
        
        ${DropdownContainer} {
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 0;
			z-index: 5055;
			border-color: transparent;
			background-color: transparent;
            
            ${DropdownHeader} {
                display: flex !important;
            }
            
          /*  &.range{
                ${ItemsContainer} {
                    height: calc(100% - 177px);
                    max-height: calc(100% - 177px);
                }
            }
            
            &.multiple {
                ${ItemsContainer} {
                    height: calc(100% - 137px);
                    max-height: calc(100% - 137px);
                }
            }*/
            
        }
    }
`;